import type { pilots as en } from '@/i18n/locales/en/pilots';
import type { Translation } from '@/i18n/types';

export const pilots: Translation<typeof en> = {
  page: {
    title: 'Pilotos',
    lead: 'Pilotos em curso na {{company}}.',
    noScope: 'Selecione uma empresa para ver os seus pilotos.',
    listTitle: 'Pilotos',
    empty: 'Ainda não há pilotos.',
  },
  status: {
    draft: 'Rascunho',
    baseline: 'Medição inicial',
    active: 'Ativo',
    interim_review: 'Avaliação intercalar',
    final_review: 'Avaliação final',
    completed: 'Concluído',
    scaled: 'Escalado',
  },
  phases: {
    baseline: 'Medição inicial',
    interim: 'Avaliação intercalar',
    final: 'Avaliação final',
  },
  kpis: {
    participationRate: 'Taxa de participação',
    activeUsers: 'Utilizadores ativos',
    dailyUsage: 'Utilização diária',
    satisfaction: 'Satisfação dos colaboradores',
    avgVitality: 'Vitalidade média',
    aiCoachUsage: 'Utilização do coach de IA',
    challengeUsage: 'Utilização de challenges',
    rolloutReadiness: 'Recomendação de expansão',
  },
  form: {
    title: 'Novo piloto',
    name: 'Nome',
    startDate: 'Data de início',
    departments: 'Departamentos',
    submit: 'Criar piloto',
  },
  detail: {
    title: 'Piloto',
    lead: 'Avaliação do piloto de vitalidade com KPI, tendências, conclusões e uma decisão de expansão fundamentada.',
    exportPdf: 'Exportar relatório (PDF)',
    hero: {
      badge: {
        success: 'Piloto bem-sucedido',
        partial: 'Piloto em curso',
        atRisk: 'Atenção necessária',
        pending: 'Piloto em execução',
      },
      goals: {
        success: 'Todas as metas de KPI atingidas',
        partial: 'Algumas metas de KPI atingidas',
        atRisk: 'Metas de KPI ainda não atingidas',
        pending: 'Ainda não há dados suficientes para uma recomendação',
      },
      headlinePrefix: {
        success:
          'O piloto prova que o NOLATR Fit melhora a vitalidade de forma mensurável — recomendação:',
        partial: 'O piloto mostra melhoria — recomendação:',
        atRisk: 'O piloto ainda não mostra melhoria mensurável — recomendação:',
        pending: 'Ainda não há dados suficientes para uma recomendação sobre',
      },
      headlineAdvice: {
        success: 'expandir para toda a organização.',
        partial: 'prolongar o piloto para obter mais dados.',
        atRisk: 'corrigir isto antes de expandir.',
        pending: 'a expansão.',
      },
    },
    summary: {
      participation: 'Participação',
      dailyActive: 'Ativos diariamente',
      stress: 'Stress',
      sleep: 'Sono',
      goal: 'meta {{value}}%',
      vsBaseline: 'vs. medição inicial',
      minutes: '{{value}} min',
    },
    aiSummaryTitle: 'Resumo de IA',
    recommendationEmpty: 'Ainda não foi escrito nenhum resumo.',
    kpisTitle: 'KPI',
    chartTitle: 'Vitalidade e atividade durante o piloto',
    chartCurrent: 'Atual',
    noData: 'Ainda não há dados.',
    participantCount: '{{count}} participantes',
    evaluationsTitle: 'Conclusões e recomendações',
    conclusionsTitle: 'Conclusões',
    recommendationsListTitle: 'Recomendações',
    evaluationsEmpty: 'Ainda não foram registadas avaliações.',
    evaluationPhase: 'Fase',
    evaluationConclusions: 'Conclusões',
    evaluationRecommendations: 'Recomendações',
    decisionTitle: 'Decisão',
    scaleRequiresCompleted: 'A expansão só é possível após a conclusão da avaliação final.',
  },
  actions: {
    new: 'Novo piloto',
    cancel: 'Cancelar',
    save: 'Guardar',
    edit: 'Editar',
    addEvaluation: 'Adicionar avaliação',
    extend: 'Prolongar',
    scale: 'Expandir',
  },
};
